import { Locales } from "@/lib/i18n";
import { getPermalink } from "@/lib/i18n/functions";
import { ContactDocumentData } from "@/prismicio-types";
import { asText, isFilled } from "@prismicio/client";

type ContactJSONLDProps = {
  data: ContactDocumentData;
  locale: Locales;
};

const ContactJSONLD = ({ data, locale }: ContactJSONLDProps) => {
  const baseUrl = process.env.NEXT_PUBLIC_FRONT_URL;
  const url = `${baseUrl}${getPermalink(locale, "contact")}`;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: data.meta_title || data.title,
    description: data.meta_description || asText(data.text),
    url,
    mainEntity: {
      "@type": "Organization",
      name: "Festi rent",
      url: baseUrl,
      ...(isFilled.keyText(data.phone) && { telephone: data.phone }),
      ...(isFilled.link(data.instagram_link) && {
        sameAs: [(data.instagram_link as { url: string }).url],
      }),
    },
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />;
};

export default ContactJSONLD;
